module.exports = __webpack_public_path__ + "static/img/plan.50c6ee69.jpeg";